import { render, staticRenderFns } from "./OnboardingSignature.vue?vue&type=template&id=9a2b9612&scoped=true"
import script from "./OnboardingSignature.vue?vue&type=script&lang=js"
export * from "./OnboardingSignature.vue?vue&type=script&lang=js"
import style0 from "./OnboardingSignature.vue?vue&type=style&index=0&id=9a2b9612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2b9612",
  null
  
)

export default component.exports